// @flow

import React from 'react';
import withLocales from '../../HOCs/withLocales';
import type {ILocalesTransformers} from '../../utils/locales';
import {StyledSiteCard, StyledBgImage, ContentContainer, Icon, Title, Subtitle, RatingsContainer, Stars} from './StyledSiteCard';

type cardProps = ILocalesTransformers & {
    key: string,
    imgPath: string,
    iconPath: string,
    title: string,
    subtitle: string,
    rating: string,
    starsPath: string,
    trackingCategory: string,
    trackingAction: string,
    trackingLabel?: string
}

export const SiteCard = withLocales((props: cardProps): any => {
    const {key, imgPath, iconPath, title, subtitle, rating, starsPath} = props;
    const redirect = (websiteClicked: string) => {
        location.href = `/scorecard/${websiteClicked}`;
    };

    return (
        <StyledSiteCard key={key} onClick={(): void => redirect(title)}>
            <StyledBgImage imgPath={imgPath}/>
            <ContentContainer>
                <Icon iconPath={iconPath}/>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
                <RatingsContainer>
                    <Subtitle>{rating}</Subtitle>
                    <Stars starsPath={starsPath}/>
                </RatingsContainer>
            </ContentContainer>
        </StyledSiteCard>
    );
});
